import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { ScrollToTopButton } from './components/ui/ScrollToTopButton';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { Safety } from './pages/Safety';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { ContactPage } from './pages/ContactPage';
import { RequestQuote } from './pages/RequestQuote';
import { Projects } from './pages/Projects';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Sitemap } from './pages/Sitemap';
import { ClientPortal } from './pages/portal/ClientPortal';
import { InternalDashboard } from './pages/admin/InternalDashboard';
import { FollowUpDashboard } from './pages/admin/FollowUpDashboard';
import { AnalyticsDashboard } from './pages/analytics/AnalyticsDashboard';
import { DigitalTwinPage } from './pages/admin/DigitalTwin';
import { DealIntelligence } from './pages/admin/DealIntelligence';
import { ClosingStrategy } from './pages/admin/ClosingStrategy';
import { AdminAuthGuard } from './pages/admin/AdminAuthGuard';
import { TenderSupport } from './pages/TenderSupport';
import { Insights } from './pages/Insights';
import { NotFound } from './pages/NotFound';
import Kimko from './pages/companies/Kimko';
import Petronix from './pages/companies/Petronix';
import SoftwareSolutions from './pages/SoftwareSolutions';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ScrollToTopButton />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/capabilities" element={<Navigate to="/services" replace />} />
        <Route path="/safety" element={<Safety />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/request-quote" element={<RequestQuote />} />
        <Route path="/request-quote-legacy" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/portal" element={<ClientPortal />} />
        <Route path="/tender-support" element={<TenderSupport />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/*" element={<Insights />} />
        <Route path="/companies/kimko" element={<Kimko />} />
        <Route path="/companies/petronix" element={<Petronix />} />
        <Route path="/software-solutions" element={<SoftwareSolutions />} />
        {/* Admin routes — protected by AdminAuthGuard, no menu links */}
        <Route path="/admin" element={<AdminAuthGuard><InternalDashboard /></AdminAuthGuard>} />
        <Route path="/admin/follow-up" element={<AdminAuthGuard><FollowUpDashboard /></AdminAuthGuard>} />
        <Route path="/admin/deal-intelligence" element={<AdminAuthGuard><DealIntelligence /></AdminAuthGuard>} />
        <Route path="/admin/closing-strategy" element={<AdminAuthGuard><ClosingStrategy /></AdminAuthGuard>} />
        <Route path="/analytics" element={<AdminAuthGuard><AnalyticsDashboard /></AdminAuthGuard>} />
        <Route path="/digital-twin" element={<AdminAuthGuard><DigitalTwinPage /></AdminAuthGuard>} />
        {/* Fallback for sub-routes in this demo */}
        <Route path="/services/*" element={<Services />} />
        {/* 404 fallback — catches all unmatched routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
